import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleRight } from '@fortawesome/free-solid-svg-icons';

const ExpandableTextBox = ({
  title,
  content,
  contentHtml,
  isExpanded,
  variant,
  className,
}) => {
  const contentRef = useRef(null);
  const [contentIsExpanded, setContentIsExpanded] = useState(
    isExpanded ?? true
  );
  const [isInitialState, setIsInitialState] = useState(true);
  const contentMinHeight = 31;

  useEffect(() => {
    if (contentIsExpanded) {
      const contentScrollHeight = contentRef.current.scrollHeight;
      if (contentScrollHeight < contentMinHeight) {
        contentRef.current.style.height = `${contentMinHeight}px`;
        contentRef.current.style.maxHeight = `${contentMinHeight}px`;
      } else {
        contentRef.current.style.maxHeight = `${contentScrollHeight}px`;
      }
    } else {
      contentRef.current.style.maxHeight = '0';
    }
  }, [contentIsExpanded]);

  const contentClassName =
    isInitialState && !contentIsExpanded
      ? 'expandable-text-box-content-initial-collapsed'
      : 'expandable-text-box-content';

  let variantClassName;
  switch (variant) {
    case 'dark':
      variantClassName = 'variant-dark';
      break;
    case 'highlight':
      variantClassName = 'variant-highlight';
      break;
    default:
      variantClassName = '';
  }

  return (
    <div
      className={`expandable-text-box ${className ?? ''} ${variantClassName}`}
    >
      <div
        className={`expandable-text-box-title show-as-clickable ${variantClassName}`}
        onClick={() => {
          setContentIsExpanded(!contentIsExpanded);
          setIsInitialState(false);
        }}
      >
        <div className={`expander-icon ${contentIsExpanded ? 'expanded' : ''}`}>
          <FontAwesomeIcon icon={faChevronCircleRight} />
        </div>
        <h4>{title}</h4>
      </div>
      <div ref={contentRef} className={contentClassName}>
        <div className="underline" />
        {contentHtml ? (
          <div dangerouslySetInnerHTML={{ __html: contentHtml }} />
        ) : (
          content
        )}
      </div>
    </div>
  );
};

export default ExpandableTextBox;
